import { faChevronLeft, faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useParams } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";
// import logo from "../../../../../assets/images/logo.png";
import { useRecoilValue } from "recoil";
import { gameProposalIdState } from "src/recoil/atoms/gameProposalState";
import { useNavigate } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GameProposalDetailsAPI, GameProposalEstimateAPI, LabsGameProposalSubmitAPI } from "../../TestManagementApi";
import InvoiceDownload from "./components/InvoiceDownload";
import LogoComponent from "./components/LogoComponent";
import { GameProposalStepAvailabilityResponse } from "../../types/Response";
import { GameProposalStepAvailabilityAPI } from "../AddTestApi";
import CustomNavLink from "../components/CustomNavLink";
import CompanyInfoCheckAPI from "src/components/pages/Home/Data/CompanyInfoCheckAPI";
import { useRef } from "react";

const GlobalStyle = createGlobalStyle`
  .invoice-download-btn {
    cursor: pointer !important;
  }
`;

const Main = styled.main`
  background-color: #f8f9fa;
  min-width: 1280px;
  max-width: 1920px;
  width: 100%;
  height: 100vh;
  
  padding-left: 195px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const TopWrapper = styled.div`
  padding-left: 80px;
  border-bottom: 1px solid #ededed;
  min-height: 157px;
  display: flex;
  flex-direction: column;
  gap: 34px;
  padding-top: 30px;
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 10;
`;

const TopContainer = styled.div`
  // width: 1280px;
  width: 95%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;


const TopTitle = styled.span`
  color: #2282e9;
  font-size: 20px;
  font-weight: 700;
`;

const BtnContainer = styled.div`
  display: flex;
  gap: 20px;
`;

const TopBtn = styled.button`
  width: 160px;
  height: 55px;
  border-radius: 5px;
  background-color: white;
  border: 1px solid #ededed;
  color: #c0c0c0;
  font-weight: 600;
  cursor: pointer;
`;

const PreviewBtn = styled(TopBtn) <{ disabled?: boolean }>`
  color: white;
  background-color: ${({ disabled }) => disabled ? "#c0c0c0" : "#2282e9"};
  cursor: ${({ disabled }) => disabled ? "not-allowed" : "pointer"};
  opacity: ${({ disabled }) => disabled ? 0.6 : 1};
`;

const SaveBtn = styled(TopBtn) <{ disabled?: boolean }>`
  color: ${({ disabled }) => disabled ? "#c0c0c0" : "#2282e9"};
  border: 1px solid ${({ disabled }) => disabled ? "#ededed" : "#2282e9"};
  cursor: ${({ disabled }) => disabled ? "not-allowed" : "pointer"};
  opacity: ${({ disabled }) => disabled ? 0.6 : 1};
`;

const NavCotainer = styled.div`
  color: #c0c0c0;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  width: 1280px;
  height: 37px;
`;

const Nav = styled.div`
  width: 165px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const AccentNav = styled(Nav)`
  border-bottom: 2px solid #2282e9;
  color: #2282e9;
`;

const ContentWrapper = styled.div`
  padding-top: 70px;
  padding-left: 125px;
  padding-bottom: 309px;
  overflow-y: auto;
  height: calc(100vh - 157px);
`;

const ContentBox = styled.div`
  // width: 1280px;
  width: 90%;
  height: calc(85vh - 100px);
  background-color: white;
  box-shadow: 0px 24px 48px 0 rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  padding: 44px 40px 33px 40px;
  box-sizing: border-box;
`;

const TitleBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LogoBox = styled.div`
  margin-bottom: 25px;
`;

const LogoImg = styled.img`
  width: 93.73px;
  height: 24.12px;
`;

const LogoSpan = styled.span`
  font-weight: 500;
  font-size: 14px;
  margin-left: 8.43px;
`;

const TextSpanBox = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #2282e9;
  line-height: 20px;
  margin-bottom: 22px;
`;

const ContentContainerWrapper = styled.div`
  display: flex;
  gap: 44px;
  height: calc(100% - 120px);
  overflow: hidden;
`;

const GrayBox = styled.div`
  background-color: #f8f9fa;
  padding: 33px 26px 35px 26px;
  border-radius: 3px;
  width: 496px;
  height: 100%;
  display: flex;
  flex-direction: row;
  overflow-y: auto;
`;

const GameInfoHeader = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

const GrayBoxImg = styled.div<{ url?: string }>`
  width: 125px;
  height: 125px;
  border-radius: 5px;
  background-color: #c0c0c0;
  margin-right: 26px;
  background-image: ${props => props.url ? `url(${props.url})` : 'none'};
  background-size: cover;
  background-position: center;
`;

const GameInfoTable = styled.table`
  margin-top: -3%;
  width: 100%;
  border-collapse: collapse;
`;

const GameInfoRow = styled.tr`
font-size: 70%;
  &:last-child {
    border-bottom: none;
  }
`;

const GameInfoTitle = styled.td`
  width: 25%;
  padding: 10px 16px;
  color: #797979;
  background-color: #f8f8f8;
  font-weight: 400;
  vertical-align: middle;
  white-space: nowrap;
`;

const GameInfoContent = styled.td`
  width: 70%;
  font-weight: 500;
  padding: 10px 16px;
  vertical-align: middle;
  line-height: 1.4;
`;

const Table = styled.div`
  width: 660px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const TableTHead = styled.div`
  height: 35px;
  display: grid;
  grid-template-columns: 250fr 151fr 152fr 92fr;
  padding-left: 15px;
  margin-top: 1%;
  margin-bottom: -1%;
`;

const TableTHeadTd = styled.div`
  font-size: 14px;
  font-weight: 500;
`;

const TBody = styled.div`
  flex: 1;
  border-top: 1.5px solid #add5ff;
  border-bottom: 1.5px solid #add5ff;
  margin-bottom: 18px;
  overflow-y: auto;
`;

const TableTBody = styled.div`
  border-bottom: 1px solid #ebf5ff;
  height: 50px;
  display: grid;
  grid-template-columns: 250fr 151fr 152fr 92fr;
  padding-left: 15px;
`;

const TableTBodyTd = styled.div`
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
`;

const PliMoneyContainer = styled.div`
  color: #2282e9;
  font-weight: 600;
  font-size: 18px;
  display: flex;
  justify-content: end;
`;

const NavLink = styled(Link)`
  width: 165px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
`;
const PliMoney = styled.div``;


const TooltipContainer = styled.div`
  position: relative;
  display: inline-flex;  // flex로 변경
  align-items: center;   // 중앙 정렬 추가
  width: 165px;
  height: 100%;         // 100%로 변경하여 부모 높이에 맞춤
`;

const Tooltip = styled.div<{ disabled?: boolean }>`
  visibility: hidden;
  position: absolute;
  top: calc(100% + 8px);  // 위치 조정
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 12px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 1000;
  
  ${TooltipContainer}:hover & {
    visibility: ${props => !props.disabled ? 'hidden' : 'visible'};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
     border-color: transparent transparent rgba(0, 0, 0, 0.8) transparent;  // 화살표 방향 변경
  }
`;


interface CompanyEverApprovedResponse {
  everApproved: boolean;
}

export default function AddTestPhase4() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  // const gameProposalId = useRecoilValue(gameProposalIdState);
  const { gameProposalId } = useParams();
  console.log(`phase4 - gameProposalId: `, gameProposalId);

  const contentBoxRef = useRef<HTMLDivElement>(null);

  const { data: companyEverApprovedData } = useQuery<CompanyEverApprovedResponse>({
    queryKey: ["companyEverApproved", gameProposalId],
    queryFn: async () => {
      const response = await CompanyInfoCheckAPI();
      return response.data;
    },
    // initialData: {
    //   everApproved: false
    // },
    enabled: true
  });

  const { data: gameProposalStepAvailabilityData } = useQuery<GameProposalStepAvailabilityResponse>({
    queryKey: ["gameProposalStepAvailability", gameProposalId],
    queryFn: async () => {
      const response = await GameProposalStepAvailabilityAPI(Number(gameProposalId));
      return response.data;
    },
    // initialData : {
    //   "testPlanAvailable" : true,
    //   "projectInfoAvailable" : false,
    //   "questionCompositionAvailable" : false,
    //   "estimateAvailable" : false,
    //   "previewAvailable" : false,
    //   "submitAvailable" : true,
    //   "testPlanSavable" : true,
    //   "projectInfoSavable" : false,
    //   "questionCompositionSavable" : false
    // },
    enabled: true
  });

  interface GameProposalDetailsResponse {
    gameProposalId: number;
    status: string;
    testPlanStatus: string;
    projectInfoStatus: string;
    questionCompositionStatus: string;
    previewAvailable: boolean;
    submitAvailable: boolean;
    gameName?: string;
  }

  const cachedGameProposalDetailsData = queryClient.getQueryData(["GameProposalOverview", gameProposalId]) as GameProposalDetailsResponse;

  const { data: gameProposalDetailsData } = useQuery<GameProposalDetailsResponse>({
    queryKey: ["GameProposalOverview", gameProposalId],
    queryFn: async () => {
      const response = await GameProposalDetailsAPI(Number(gameProposalId));
      return response.data;
    },
    enabled: !cachedGameProposalDetailsData,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  // API 제출을 위한 mutation 설정
  const submitMutation = useMutation({
    mutationFn: () => LabsGameProposalSubmitAPI(Number(gameProposalId), {}),
    onSuccess: (response) => {
      if (response.status === 200) {
        console.log("제출 성공");
        navigate("/home/test-list/add/finish", {
          state: {
            title: gameProposalEstimateData?.basicInfo.title
          }
        });
      }
    },
    onError: (error) => {
      console.error("제출 실패:", error);
      // 에러 처리 로직 추가 가능
    }
  });

  const handleSave = () => {
    console.log("저장하기 및 API 호출");
    submitMutation.mutate();
  };

  const { data: gameProposalEstimateData } = useQuery({
    queryKey: ['gameProposalEstimate'],
    queryFn: async () => {
      const response = await GameProposalEstimateAPI(Number(gameProposalId));
      return response.data;
    },
    // initialData:{
    //   "basicInfo" : {
    //     "title" : "GAME_TITLE",
    //     "companyName" : "무모게임즈",
    //     "desiredTesterCount" : 50,
    //     "platforms" : [ "PC", "MOBILE", "CONSOLE" ],
    //     "rewards" : 1500,
    //     "questionSource" : "플리더스 추천 질문",
    //     "multipleChoiceQuestionCount" : 5,
    //     "subjectiveQuestionCount" : 4,
    //     "recruitDays" : 10,
    //     "testDays" : 11,
    //     "gameCategory" : "CBT",
    //     "bannerUrl" : "https://plithus-dev.s3.ap-northeast-2.amazonaws.com/admins/images/games/15122-ca897976-a71a-40af-9b79-c83b4d52f7b3.png"
    //   },
    //   "pricingInfo" : {
    //     "details" : [ {
    //       "service" : "희망 테스트 유저 수",
    //       "count" : 50,
    //       "unitPrice" : 10,
    //       "totalPrice" : 500
    //     }, {
    //       "service" : "유저 지급 재화",
    //       "count" : 50,
    //       "unitPrice" : 1500,
    //       "totalPrice" : 25000
    //     }, {
    //       "service" : "객관식 질문 추가",
    //       "count" : 1,
    //       "unitPrice" : 20,
    //       "totalPrice" : 20
    //     }, {
    //       "service" : "주관식 질문 추가",
    //       "count" : 1,
    //       "unitPrice" : 30,
    //       "totalPrice" : 30
    //     } ],
    //     "totalPlimoney" : 25550
    //   }
    // },
    enabled: true
  });

  return (
    <Main>
      <GlobalStyle />
      <div>
        <TopWrapper>
          <TopContainer>
            <Link to={`/home/test/draft/${gameProposalId}`} style={{ textDecoration: "none" }}>
              <TopTitle>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  style={{ marginRight: "20px" }}
                />
                4단계 견적 확인
              </TopTitle>
            </Link>
            <BtnContainer>
              <TooltipContainer>
                <PreviewBtn 
                  onClick={() => navigate(`/home/test/preview/${gameProposalId}`)}
                  disabled={!companyEverApprovedData?.everApproved}
                >
                  미리보기
                </PreviewBtn>
                <Tooltip disabled={!companyEverApprovedData?.everApproved}>
                  게임사 승인이 완료되지 않았습니다.
                </Tooltip>
              </TooltipContainer>
              <TooltipContainer>
                <SaveBtn
                  onClick={handleSave}
                  disabled={!companyEverApprovedData?.everApproved || gameProposalStepAvailabilityData?.submitAvailable === false}
                >
                  제출하기
                </SaveBtn>
                <Tooltip disabled={!companyEverApprovedData?.everApproved}>
                  게임사 승인이 완료되지 않았습니다.
                </Tooltip>
                <Tooltip disabled={cachedGameProposalDetailsData?.status === "APPROVED" || gameProposalDetailsData?.status === "APPROVED"}>
                  이미 제출 완료된 테스트입니다.
                </Tooltip>

              </TooltipContainer>
            </BtnContainer>
          </TopContainer>
          <NavCotainer>
            <CustomNavLink
              to={`/home/test-list/${gameProposalId}/add/first`}
              status={gameProposalStepAvailabilityData?.testPlanAvailable}
            >
              1. 테스트 플랜
            </CustomNavLink>
            <CustomNavLink
              to={`/home/test-list/${gameProposalId}/add/second`}
              status={gameProposalStepAvailabilityData?.projectInfoAvailable}
            >
              2. 프로젝트 정보
            </CustomNavLink>
            <CustomNavLink
              to={`/home/test-list/${gameProposalId}/add/third`}
              status={gameProposalStepAvailabilityData?.questionCompositionAvailable}
            >
              3. 질문 구성
            </CustomNavLink>
            <CustomNavLink
              to={`/home/test-list/${gameProposalId}/add/forth`}
              status={gameProposalStepAvailabilityData?.estimateAvailable}
              isActive={true}
            >
              4. 견적 확인
            </CustomNavLink>
          </NavCotainer>
        </TopWrapper>
        <ContentWrapper>
          <ContentBox ref={contentBoxRef} className="content-box">
            <TitleBox>
              <div style={{ width: "100%" }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <LogoComponent />
                  <div className="invoice-download-btn">
                    <InvoiceDownload contentBoxRef={contentBoxRef} />
                  </div>
                </div>
                <TextSpanBox>
                  플리더스 테스트 제작소
                  <br />
                  Date {new Date().getFullYear()} . {String(new Date().getMonth() + 1).padStart(2, '0')} . {String(new Date().getDate()).padStart(2, '0')}
                </TextSpanBox>
              </div>

            </TitleBox>
            <ContentContainerWrapper>
              <GrayBox>
                <GameInfoHeader>
                  <GrayBoxImg url={gameProposalEstimateData?.basicInfo.bannerUrl}></GrayBoxImg>
                </GameInfoHeader>
                <GameInfoTable>
                  <tbody>
                    <GameInfoRow>
                      <GameInfoTitle>게임이름</GameInfoTitle>
                      <GameInfoContent>{gameProposalEstimateData?.basicInfo.title}</GameInfoContent>
                    </GameInfoRow>
                    <GameInfoRow>
                      <GameInfoTitle>게임사</GameInfoTitle>
                      <GameInfoContent>{gameProposalEstimateData?.basicInfo.companyName}</GameInfoContent>
                    </GameInfoRow>
                    <GameInfoRow>
                      <GameInfoTitle>모집기간</GameInfoTitle>
                      <GameInfoContent>{gameProposalEstimateData?.basicInfo.recruitDays}일</GameInfoContent>
                    </GameInfoRow>
                    <GameInfoRow>
                      <GameInfoTitle>진행기간</GameInfoTitle>
                      <GameInfoContent>{gameProposalEstimateData?.basicInfo.testDays}일</GameInfoContent>
                    </GameInfoRow>
                    <GameInfoRow>
                      <GameInfoTitle>희망 유저수</GameInfoTitle>
                      <GameInfoContent>{gameProposalEstimateData?.basicInfo.desiredTesterCount}명</GameInfoContent>
                    </GameInfoRow>
                    <GameInfoRow>
                      <GameInfoTitle>게임 플랫폼</GameInfoTitle>
                      <GameInfoContent>{gameProposalEstimateData?.basicInfo.platforms.join(", ")}</GameInfoContent>
                    </GameInfoRow>
                    <GameInfoRow>
                      <GameInfoTitle>게임 테스트 유형</GameInfoTitle>
                      <GameInfoContent>{gameProposalEstimateData?.basicInfo.gameCategory === null || gameProposalEstimateData?.basicInfo.gameCategory === undefined || gameProposalEstimateData?.basicInfo.gameCategory === "" ? "CBT" : gameProposalEstimateData?.basicInfo.gameCategory}</GameInfoContent>
                    </GameInfoRow>
                    <GameInfoRow>
                      <GameInfoTitle>지급재화</GameInfoTitle>
                      <GameInfoContent>{gameProposalEstimateData?.basicInfo.rewards.toLocaleString()} 포인트</GameInfoContent>
                    </GameInfoRow>
                    <GameInfoRow>
                      <GameInfoTitle>질문 유형</GameInfoTitle>
                      <GameInfoContent>{gameProposalEstimateData?.basicInfo.questionSource}</GameInfoContent>
                    </GameInfoRow>
                    <GameInfoRow>
                      <GameInfoTitle>객관식 질문 수</GameInfoTitle>
                      <GameInfoContent>{gameProposalEstimateData?.basicInfo.multipleChoiceQuestionCount}개</GameInfoContent>
                    </GameInfoRow>
                    <GameInfoRow>
                      <GameInfoTitle>주관식 질문 수</GameInfoTitle>
                      <GameInfoContent>{gameProposalEstimateData?.basicInfo.subjectiveQuestionCount}개</GameInfoContent>
                    </GameInfoRow>
                  </tbody>
                </GameInfoTable>
              </GrayBox>
              <Table>
                <TableTHead>
                  <TableTHeadTd>서비스</TableTHeadTd>
                  <TableTHeadTd>갯수</TableTHeadTd>
                  <TableTHeadTd>단가</TableTHeadTd>
                  <TableTHeadTd>총합</TableTHeadTd>
                </TableTHead>
                <TBody>
                  {gameProposalEstimateData?.pricingInfo.details.map((detail: any, index: number) => (
                    <TableTBody key={index}>
                      <TableTBodyTd>{index + 1}. {detail.service}</TableTBodyTd>
                      <TableTBodyTd>{detail.count}</TableTBodyTd>
                      <TableTBodyTd>{detail.unitPrice.toLocaleString()}</TableTBodyTd>
                      <TableTBodyTd>{detail.totalPrice.toLocaleString()}</TableTBodyTd>
                    </TableTBody>
                  ))}
                </TBody>
                <PliMoneyContainer>
                  <PliMoney style={{ marginRight: "57px" }}>총 견적</PliMoney>
                  <PliMoney>{gameProposalEstimateData?.pricingInfo.totalPlimoney.toLocaleString()} 플리머니</PliMoney>
                </PliMoneyContainer>
              </Table>
            </ContentContainerWrapper>
          </ContentBox>
        </ContentWrapper>
      </div>
    </Main>
  );
}
